module.exports = __webpack_public_path__ + "img/21_pc.8c304bd6.gif";